import request from '@/utils/request'
export function getPhotoGroup() {
  return request({
    url:'/group/list/photo',
    method:'get',
  })
}
export function getPhotosInGroup(groupId) {
  return request({
    url:'/group/getPhotoByGroup',
    method:'post',
    data: {
      "groupBid":groupId,
      "pageNum":1,
      "pageSize":1000
    }
  })
}
export function upLoadPhotosInGroup(groupId,name,formData,token) {
  return request({
    url:'/fileManager/uploadPicture/' + groupId + '?name=' + name,
    method:'post',
    config:{
      headers:{'Content-Type':'multipart/form-data','token':token}
    },
    data: formData
  })
}
